import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

/** Full-page navigation to URLs outside the Angular router. */
@Injectable({ providedIn: 'root' })
export class ExternalNavigation {
  private readonly document = inject(DOCUMENT);

  assign(url: string): void {
    this.document.location.assign(url);
  }
}
